import { isPhone } from '@helpers';

export const DASHBOARD_SUMMARY_CARD_CONFIG = {
  height: isPhone ? 48 : 64,
  radius: 12,
  gap: isPhone ? 8 : 12,
  innerGap: isPhone ? 2 : 4,
  opacity: 0.12,
};
